import React, { useState, useContext, useEffect, useRef } from 'react';
import { AuthContext } from "../contexts/AuthContext";
import { CSpinner, CModal, CModalBody, CTooltip, CModalHeader, CButton, CModalFooter } from '@coreui/react';
import axios from 'axios';
import './Dashboard.scss'
import './Dashboard.css'
import EditRestaurante from './EditRestaurante';
import QR from './QR'

const Dashboard = () => {
  let { user1 } = useContext(AuthContext);
  const qrRef = useRef(null)
  let [info, setInfo] = useState()
  let [infoOG, setInfoOG] = useState()
  let [totalRestaurants, setTotalRestaurants] = useState()
  let [users, setUsers] = useState([])
  let [totalUsers, setTotalUsers] = useState()
  let [totalBebidas, setTotalBebidas] = useState()
  let [beneficios, setBeneficios] = useState()
  let [beneficiosTotal, setBeneficiosTotal] = useState([])
  let [visible2, setVisible2] = useState(false)
  let [visible3, setVisible3] = useState(false)
  let [idparaQR, setIdparaQR] = useState()

  const downloadQR = () => {
    if (!qrRef.current) return

    const canvas = qrRef.current.querySelector('canvas')
    if (!canvas) return

    const link = document.createElement('a')
    link.download = `Qr_${info.name.replace(/[^a-zA-Z0-9]/g, '')}.jpg`
    link.href = canvas.toDataURL('image/jpeg', 1.0)
    link.click()
  }

  useEffect(() => {
    if (!user1?.id) return

    if (user1.role == 'master') {
      axios.get(`${process.env.REACT_APP_BackURL}/countRestaurants`)
        .then((response) => { setTotalRestaurants(response.data.data); })
        .catch((err) => { console.log(err) })

      axios.get(`${process.env.REACT_APP_BackURL}/countUsers`)
        .then((response) => { setTotalUsers(response.data.data); })
        .catch((err) => { console.log(err) })

      axios.get(`${process.env.REACT_APP_BackURL}/getAllUsers`)
        .then((response) => { setUsers(response.data.data); })
        .catch((err) => { console.log(err) })

      axios.get(`${process.env.REACT_APP_BackURL}/countDrinks`)
        .then((response) => { setTotalBebidas(response.data.data); })
        .catch((err) => { console.log(err) })

      axios.get(`${process.env.REACT_APP_BackURL}/getAllRestaurantHistory`)
        .then((response) => {
          let hoy = new Date();
          hoy.setHours(0, 0, 0, 0);
          setBeneficiosTotal(response.data.data.filter(pedido => new Date(pedido.date) >= hoy));
        })
        .catch((err) => { console.log(err) })
    }

    if (user1.role == "restaurant") {

      axios.get(`${process.env.REACT_APP_BackURL}/getRestaurantById?id=${user1.id}`)
        .then((response) => { setInfo(response.data.data); })
        .catch((err) => { console.log(err) })

      axios.get(`${process.env.REACT_APP_BackURL}/getRestaurantHistoryByRestaurantID?restaurantID=${user1.id}`)
        .then((response) => {
          let hoy = new Date();
          hoy.setHours(0, 0, 0, 0);
          setBeneficios(response.data.data.filter(pedido => new Date(pedido.date) >= hoy));
        })
        .catch((err) => { console.log(err) })

    }

  }, [user1.id])

  return (
    <>
      <CModal size='xl' visible={visible2} onClose={() => { setVisible2(false) }}>
        <CModalHeader closeButton>Editar restaurante</CModalHeader>
        <CModalBody>
          <EditRestaurante portalRestaurante={true} setVisible2={setVisible2} infoEdit={info} infoEditOG={infoOG} setInfoEdit={setInfo} />
        </CModalBody>
      </CModal>

      <CModal visible={visible3} onClose={() => setVisible3(false)}>
        <CModalHeader closeButton>Descarga el Qr</CModalHeader>

        <CModalBody style={{ display: 'flex', justifyContent: "center", alignItems: 'center' }}>
          <QR id={idparaQR} ref={qrRef} />
        </CModalBody>

        <CModalFooter>
          <CButton color="success" onClick={downloadQR}>Descargar JPG</CButton>
        </CModalFooter>
      </CModal>

      <br />

      <center>

        <h3>Dashboard</h3>

        {
          user1.role == 'restaurant' &&
          <div style={{ display: 'flex', gap: '10px' }}>
            <CButton color="info" onClick={() => { setVisible2(true); setInfoOG(info) }}>
              Editar información de restaurante &nbsp;
              <i className="fa-solid fa-pen-to-square"></i>
            </CButton>
            <CTooltip content="qr">
              <CButton color='warning' onClick={() => { setIdparaQR(info._id); setVisible3(true) }}>
                Descargar Qr &nbsp;
                <i className="fa-solid fa-qrcode"></i>
              </CButton>
            </CTooltip>
          </div>
        }

      </center>

      <br />

      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: '30px' }}>


        {
          user1.role == "restaurant" &&
          <>
            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/bebidas">
                <div className="card l-bg-cherry">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-martini-glass-citrus"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Bebidas registradas</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{info ? info.drinks.length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/entregaBeneficios">

                <div className="card l-bg-blue-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-martini-glass-citrus"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Bebidas entregadas</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{beneficios ? beneficios.filter(b => b.delivered).length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/entregaBeneficios">

                <div className="card l-bg-green">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-martini-glass-citrus"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Bebidas por entregar</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{beneficios ? beneficios.filter(b => !b.delivered).length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>
          </>
        }

        {
          user1.role == "master" &&
          <>
            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/restaurantes">

                <div className="card l-bg-blue-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-utensils"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Restaurantes registrados</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{totalRestaurants ? totalRestaurants : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/usuarios">

                <div className="card l-bg-cherry">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-users"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Usuarios registrados</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{totalUsers ? totalUsers : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/usuarios">

                <div className="card l-bg-yellow-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-users"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Suscriptores</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{users.length > 0 ? users.filter(u => u.activeSubscription).length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <a className='noDecoration' href="/usuarios">

                <div className="card l-bg-aqua-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-users"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Suscriptores cancelando</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{users.length > 0 ? users.filter(u => u.activeSubscription && u.canceling).length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </a>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <div className='noDecoration'>

                <div className="card l-bg-green-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-martini-glass-citrus"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Bebidas registradas</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{totalBebidas ? totalBebidas : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <div className='noDecoration'>

                <div className="card l-bg-orange-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-gift"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Beneficios registrados</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{beneficiosTotal.length >= 0 ? beneficiosTotal.length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <div className='noDecoration'>

                <div className="card l-bg-red-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-check"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Beneficios entregados</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{beneficiosTotal.length >= 0 ? beneficiosTotal.filter(beneficio => beneficio.status === 'Entregado').length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <div className='noDecoration'>

                <div className="card l-bg-yellow-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-spinner"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Beneficios por entregar</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{beneficiosTotal.length >= 0 ? beneficiosTotal.filter(beneficio => beneficio.status === 'Pendiente').length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6" style={{ maxHeight: '200px', minWidth: '300px' }}>
              <div className='noDecoration'>

                <div className="card l-bg-aqua-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="card-icon card-icon-large">
                      <i className="fas fa-xmark"></i>
                    </div>

                    <div className="mb-4">
                      <h6 className="card-title mb-0">Beneficios cancelados</h6>
                    </div>

                    <div className="row align-items-center mb-2 d-flex">
                      <div className="col-8">
                        <h2 className="d-flex align-items-center mb-0">{beneficiosTotal.length >= 0 ? beneficiosTotal.filter(beneficio => beneficio.status === 'Cancelado').length : <CSpinner />} &nbsp;&nbsp;&nbsp;&nbsp;{" "}</h2>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </>
        }

      </div>

      <br /><br />
    </>
  )
}

export default Dashboard
